exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-drawer .el-drawer__body{height:100%}", ""]);

// exports
